<template>
  <div class="mb-4 pb-4 border-b border-gray-25">
    <p class="uppercase font-bold text-lg text-indigo-base">
      {{ props.title }}
    </p>
  </div>
</template>

<script setup>
import { defineProps } from "vue";

const props = defineProps({
  title: {
    type: String,
    default: "",
  },
});
</script>
